"use client";

import { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import leftArrowSvg from "../../../Assets/leftArrowSvg.svg";
import rightArrowSvg from "../../../Assets/rightArrowSvg.svg";
import { ArrowUpCircle } from "lucide-react";
import { setStep3Data } from "../../../stepSlice";
import {
  get_all_data_onboarding,
  insert_update_business_data_onboarding,
  server_post_data,
} from "../../../ServiceConnection/serviceconnection";
import { handleError } from "../../../CommonJquery/CommonJquery";
import OnboadingShimmer from "../Pages/OnboadingShimmer";
import OnboardingLoader from "../Pages/OnboadingLoader";
import "../../CSS/NewOnboading/Step4.css";
import "../../CSS/NewOnboading/Step3.css";

export default function Step4Page({ onBack, onNext, goToStep }) {
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [error, setError] = useState(false);
  const [error2, setError2] = useState(false);
  const dispatch = useDispatch();

  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const [businessTypes, setbusinessTypes] = useState([]);
  const [totalselect, settotalselect] = useState(3);
  const [businessImage, setbusinessImage] = useState("");
  const scrollContainerRef = useRef(null);
  const upgradeBtnRef = useRef(null);
  const scrollToTopWithOffset = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      setTimeout(() => {
        scrollContainerRef.current.scrollBy({
          top: -1400,
          behavior: "smooth",
        });
      }, 200);
    }
  };

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("flag", "4");
    await server_post_data(get_all_data_onboarding, fd)
      .then((Response) => {
        const data = Response.message.split("~@~");
        const final_data = JSON.parse(data[1]);
        if (parseInt(data[0]) === 1) {
          handleError(final_data.message);
        } else {
          setbusinessTypes(final_data.review_linkss_data);
          if (final_data.onboarding_data.length > 0) {
            settotalselect(
              Number.parseInt(final_data.onboarding_data[0].total_select),
            );
          }
          setSelectedTypes(final_data.review_linkss_data2);
          setbusinessImage(final_data.review_linkss_link);
        }
        setShowLoaderAdmin(false);
      })
      .catch(() => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    master_data_get();
  }, []);

  useEffect(() => {
    if (error || error2) {
      scrollToTopWithOffset();
    }
  }, [error, error2]);

  const handleNext = async () => {
    if (selectedTypes.length === 0) {
      setError(true);
    } else {
      setIsLoading(true);
      const fd_from = new FormData();
      fd_from.append("flag", "4");
      selectedTypes.forEach((type, i) => {
        fd_from.append("review_linkss_data_" + i, type.rll_id);
      });
      fd_from.append("review_count", selectedTypes.length);
      await server_post_data(insert_update_business_data_onboarding, fd_from)
        .then((Response) => {
          setIsLoading(false);
          let data = Response.message.split("~@~");
          const final_data = JSON.parse(data[1]);
          if (parseInt(data[0]) === 1) {
            handleError(final_data.message);
          } else {
            dispatch(setStep3Data(selectedTypes));
            onNext(final_data.step_save);
          }
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };
  const handleTypeSelect = (type) => {
    const alreadySelected = selectedTypes.find((t) => t.rll_id === type.rll_id);

    if (alreadySelected) {
      setSelectedTypes((prev) => prev.filter((t) => t.rll_id !== type.rll_id));
    } else {
      if (selectedTypes.length >= totalselect) {
        setError2(true);
        scrollToTopWithOffset();

        // Trigger shake animation on Upgrade button
        if (upgradeBtnRef.current) {
          upgradeBtnRef.current.classList.add("shake-upgrade");
          setTimeout(() => {
            upgradeBtnRef.current.classList.remove("shake-upgrade");
          }, 500);
        }

        return;
      } else {
        setSelectedTypes((prev) => [...prev, type]);
      }
    }

    setError(false);
    setError2(false);
  };

  const isSelected = (id) => {
    return selectedTypes.some((t) => t.rll_id === id);
  };

  console.log("setStep", goToStep);

  return (
    <div className="col-xl-8 col-lg-10 mx-auto">
      {ShowLoaderAdmin && <OnboadingShimmer />}
      {IsLoading && <OnboardingLoader />}
      <div className="select_platform_container">
        <div className="height_ovr_flow_clss_step4" ref={scrollContainerRef}>
          <h3>Where would you like feedback from?</h3>
          <div className="d-flex justify-content-center align-items-center">
            <label>
              Select the platforms that matter most to your business. These will
              appear when a customer scans your QR
              <br />
              guiding them to leave feedback where it counts..
            </label>
          </div>

          <div className="d-flex gap-2 justify-content-center align-items-center">
            {error && (
              <span style={{ color: "red" }} className="margin_errr">
                (Please select at least one)
              </span>
            )}
            {error2 && (
              <span style={{ color: "red" }} className="margin_errr">
                You can choose up to {totalselect} platforms with the Basic
                plan.
                <br />
                🔓{" "}
                <span className="upgrade_text_span" onClick={() => goToStep(2)}>
                  Upgrade
                </span>{" "}
                your Plan for more platform integrations and analytics.
              </span>
            )}
          </div>

          <div className="bussiness_typeCard" style={{ position: "relative" }}>
            <div className="row ">
              {businessTypes.map((type, index) => (
                <div
                  className="col-md-3 col-sm-3  col-6 mrging_clss"
                  key={index}
                  style={{
                    opacity:
                      isSelected(type.rll_id) ||
                      selectedTypes.length < totalselect
                        ? 1
                        : 0.7,
                  }}
                >
                  <div className="cardf_contre ">
                    <div
                      className={`type-card ${
                        isSelected(type.rll_id) ? "active" : ""
                      }`}
                      onClick={() => handleTypeSelect(type)}
                    >
                      <img
                        src={
                          businessImage + type.review_logo || "/placeholder.svg"
                        }
                        className="icon1"
                        alt={type.review_name}
                      />
                    </div>
                    <h4>{type.review_name}</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="pre_next_bttn_div">
          <button className="prevBtn" onClick={onBack}>
            <img
              src={leftArrowSvg || "/placeholder.svg"}
              alt="left"
              className="leftArrowSvg"
            />
            Back
          </button>

          <div className="Next_upd_gap">
            <button className="nextBtn" onClick={handleNext}>
              Next
              <img
                src={rightArrowSvg || "/placeholder.svg"}
                alt="right"
                className="right_arrw_svg"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
